import React from 'react';
import { Skeleton } from '../ui/skeleton';

const gridColsMap = {
  2: 'grid-cols-2',
  3: 'grid-cols-2 md:grid-cols-3',
  4: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
};

const ProductGridSkeleton = ({ columns = 4, count = 8 }) => {
  const gridCols = gridColsMap[columns] || gridColsMap[4];
  return (
    <div className={`grid ${gridCols} w-full min-w-0 gap-x-1 gap-y-3 sm:gap-y-4 md:gap-x-4 md:gap-y-6`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="w-full min-w-0">
          <Skeleton className="aspect-[3/5] w-full rounded-none" />
          <div className="space-y-1 px-3 pb-1.5 pt-2">
            <Skeleton className="h-3 w-full max-w-[85%]" />
            <Skeleton className="h-3 w-1/2" />
            <Skeleton className="h-2.5 w-1/4" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductGridSkeleton;
